module.exports = __webpack_public_path__ + "static/media/MyStores.f4e54546.png";